import apiInstance from '../config/api/axios'
import moment from 'moment';
export const getSummaryReport = async(payload) => {

payload.start_date = moment(payload.start_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
payload.end_date   = moment(payload.end_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
    const response = await apiInstance.post('/getSummaryReport', payload)

    return response
}

export const getLenderReport = async(payload, query) => {
     payload.start_date = moment(payload.start_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
    payload.end_date   = moment(payload.end_date, 'DD-MM-YYYY').format('YYYY-MM-DD');  
   payload['download']=true;
   payload['mask']=true;
    const response = await apiInstance.post(`/getLenderData`, payload)

    return response
}

export const getBorrowerReport = async(payload, query) => {
   // const response = await apiInstance.post(`/v1/sales/getBorrowerData/query?page=${query.page}&limit=${query.limit}`, payload)
     payload['download']=true;
     payload['mask']=true;
      payload.start_date = moment(payload.start_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
    payload.end_date   = moment(payload.end_date, 'DD-MM-YYYY').format('YYYY-MM-DD');  
     const response = await apiInstance.post(`/getBorrowerData`, payload)
  
    return response
}

export const getBorrowerLoanReport = async(payload, query) => {
    payload.start_date = moment(payload.start_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
    payload.end_date   = moment(payload.end_date, 'DD-MM-YYYY').format('YYYY-MM-DD');  
   const response = await apiInstance.post(`/getLoanByDate`, payload)
    return response
}

export const getBorrowerRepaymentReport = async(payload, query) => {
   payload.start_date = moment(payload.start_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
   payload.end_date   = moment(payload.end_date, 'DD-MM-YYYY').format('YYYY-MM-DD');  
   const response = await apiInstance.post(`/getBorrowerRepayment`, payload)
    return response
}